/* eslint-disable unicorn/consistent-function-scoping */
/* eslint-disable new-cap */
import { destroyUser } from 'reactApp/modules/user/user.actions';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { updateUser } from 'reactApp/modules/user/user.thunkActions';
import { showAuth } from 'reactApp/utils/auth';

import { setPhListnerAction, setPrevEmail } from './ph.actions';
import { getSuccessPage, reloadPage } from './ph.helpers';
import { getPhListner, getPrevEmail } from './ph.selectors';
import { AuthPopupAction, Params } from './ph.types';

export const authPopup =
    (data: AuthPopupAction = {}) =>
    async (dispatch, getState) => {
        const { closable = false, successPage, loginRequest } = data;
        if (typeof window.__PH === 'undefined') {
            return;
        }

        window.__PH.loadAccountsList(({ accounts }) => {
            const params: Params = {
                closable,
                successPage,
                page: successPage,
                opener: 'cloud',
            };

            if (!loginRequest) {
                const login = UserSelectors.getLogin(getState());
                const domain = UserSelectors.getDomain(getState());
                params.formType = accounts && accounts.length ? 'restore' : 'relogin';

                if (login || domain) {
                    params.login = login;
                    params.domain = domain;
                }

                dispatch(destroyUser());
            }

            showAuth(params);
        });
    };

// eslint-disable-next-line unicorn/consistent-function-scoping
const authPopupHide = () => (dispatch) => {
    dispatch(updateUser())
        .then(() => {
            // @ts-ignore
            RADAR.beaconImmediate('auth_relogin').after(() => {
                window.__PH.authForm.hide();
            });
        })
        .catch(() => reloadPage());
};

export const authUpdate =
    ({ data }, next) =>
    (dispatch, getState) => {
        const newEmail = data.email || null;
        const prevEmail = getPrevEmail(getState());

        if (prevEmail && newEmail !== prevEmail) {
            dispatch(setPrevEmail({ prevEmail: null }));

            dispatch(authPopupHide());
        }

        next();
    };

export const authLost = () => (dispatch, getState) => {
    const prevEmail = getPrevEmail(getState());

    if (!prevEmail) {
        dispatch(setPrevEmail({ prevEmail: UserSelectors.getEmail(getState()) }));

        // @ts-ignore
        RADAR('auth_lost');

        dispatch(authPopup({ successPage: getSuccessPage(window.location) }));
    }
};

export const loginRequest = (e, next) => (dispatch) => {
    // @ts-ignore
    RADAR('auth_login-request');

    const successPage = getSuccessPage(window.location);

    dispatch(authPopup({ closable: true, successPage, loginRequest: true }));

    next();
};

export const authChange =
    ({ data }, next) =>
    (dispatch) => {
        if (data.email) {
            reloadPage();
        } else {
            // @ts-ignore

            RADAR('auth_lost');
            dispatch(authPopup({ successPage: getSuccessPage(window.location) }));
        }

        next();
    };

export const setPhListner = () => (dispatch, getState) => {
    const phListner = getPhListner(getState());

    return new Promise<void>((resolve) => {
        if (phListner) {
            return resolve();
        }

        dispatch(setPhListnerAction({ value: true }));

        if (typeof window.__PH !== 'undefined') {
            window.__PH.on('authLost', () => dispatch(authLost()));
            window.__PH.on('update', (e, next) => dispatch(authUpdate(e, next)));
            window.__PH.on('loginRequest', (e, next) => dispatch(loginRequest(e, next)));
            window.__PH.on('authChange', (e, next) => dispatch(authChange(e, next)));
        }

        return resolve();
    });
};
